import styled from "styled-components";

import { QUERIES, SPACING, SPACING_RESPONSIVE } from "../../../utils/constants";

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  margin: ${SPACING_RESPONSIVE.mobile.pageMargin}px;
  padding: ${SPACING_RESPONSIVE.mobile.cardPadding}px;
  border-radius: ${SPACING.md}px;
  background: var(--hero-background);
  border: 1px solid var(--color-border-light);
  box-shadow: var(--shadow-small);

  @media ${QUERIES.tabletAndUp} {
    margin: ${SPACING_RESPONSIVE.tablet.pageMargin}px;
    padding: ${SPACING_RESPONSIVE.tablet.cardPadding}px;
  }

  @media ${QUERIES.tabletLargeAndUp} {
    margin: ${SPACING_RESPONSIVE.desktop.pageMargin}px;
  }
`;

export const Frame = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${SPACING.md}px;
  padding: ${SPACING.xl}px ${SPACING.lg}px;
  border: 1px dashed var(--empty-state-border);
  border-radius: ${SPACING.md}px;
  background: var(--empty-state-background);
  text-align: center;

  @media ${QUERIES.tabletLargeAndUp} {
    padding: ${SPACING.xxl}px ${SPACING.lg}px;
    gap: ${SPACING.lg}px;
  }
`;

export const Title = styled.h2`
  margin: 0;
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-xl);
  font-weight: var(--font-weight-bold);
  letter-spacing: -0.01em;
  color: var(--color-text-default);

  @media ${QUERIES.tabletLargeAndUp} {
    font-size: var(--text-xxl);
  }
`;

export const Description = styled.p`
  margin: 0;
  max-width: 42ch;
  font-size: var(--text-base);
  line-height: 1.6;
  color: var(--color-text-secondary);
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${SPACING.sm}px;
  width: 100%;
  margin-top: ${SPACING.xs}px;

  @media ${QUERIES.tabletLargeAndUp} {
    flex-direction: row;
  }
`;

export const PlusBadge = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--color-success);
  border: 2px solid var(--empty-state-background);
  box-shadow: var(--shadow-small);

  svg {
    color: var(--color-white);
    font-size: var(--text-md);
  }
`;
